import tw from 'twin.macro';

export const Input = tw.input`
 w-[16rem] focus:bg-gray-300 focus:border focus:border-gray-400
  rounded-lg bg-gray-200 outline-none p-3
`;

export const Label = tw.label`
 text-base font-medium mb-2
`;
